import { FC } from "react"
import { Component } from "../../types/ContentStructure"
import { CardMedia, Link } from "@mui/material"

interface IComponentLogoProps {
    component: Component
    sx?: any
}

const ComponentLogo: FC<IComponentLogoProps> = ({ component, sx }) => {
    return (
        <Link href={component.link} rel="noopener noreferrer">
            <CardMedia
                component="img"
                sx={[component.theme.themeStyles, {
                    display: 'flex',
                    flexGrow: { sm: 'none', md: 1 },
                    cursor: 'pointer',
                    alignItems: 'center',
                    objectFit: 'contain',
                    maxWidth: { xs: 60, sm: 80, md: 120 },
                },
                { ...sx }]}
                image={component.image ?? undefined}
                alt={component.title}
            />
        </Link>
    )
}

export default ComponentLogo
